import TextBox from './TextBox';
import cn from 'classnames';

export default function DollarBox({
                                      className,
                                      ...props
                                  }: any) {
    return <span className="input-with-icon">
        <span className="input-left-icon">$</span>
        <TextBox type="number" className={cn('amount-input', className)} min="-1000000000" step="0.01"
                 max="1000000000" {...props}/>
    </span>
}
